export default {
  // 进度条文本
  processList(state) {
    // 如果是协议交易
    if(Number(state.tradeType) === 2) {
      return state.processListByTrade;
    } else {
      return state.processList;
    }
  },
  // 交易方式
  tradeType(state) {
    return state.tradeType;
  },
  // 转让方式
  transferType(state) {
    return state.transferType;
  }
};
